var isServer = function isServer() {
  return typeof window !== 'object';
};

export default isServer;